export default __webpack_public_path__ + "static/media/QR_code_AppGallery.c28da4e3.png";